import { gql } from "@apollo/client";
import { SubmissionStatus } from "../types";
import { CURRENT_MEMBER_FRAGMENT, MY_ACTIVITY_DETAILS_FRAGMENT } from "../fragments";

export interface Query {
  currentMember: {
    deferredCompSubmission: {
      id: string;
      completionDate: string;
      expirationDate: string;
      reviewRequestDate: string;
      statusChangedAt: string;
      createdAt: string;
      expiresSoon: boolean;
      status: SubmissionStatus;
      comments: string;
      rejectionMessage: string;
      rejectionReason: string;
      reviewer: {
        id: string;
        name: string;
        firstName: string;
        lastName: string;
        profilePhoto: string;
      };
      participationLevel: {
        activity: {
          name: string;
          description: string;
          tags: { name: string }[];
        };
        points: number;
        requirements: string;
      };
    };
  };
}

export const QUERY = gql`
  query MyActivity($id: ID!) {
    currentMember {
      ...CurrentMemberFragment
      deferredCompSubmission(id: $id) {
        ...MyActivityDetailsFragment
      }
    }
  }
  ${MY_ACTIVITY_DETAILS_FRAGMENT}
  ${CURRENT_MEMBER_FRAGMENT}
`;
